import script from "./FormComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormComponent.vue?vue&type=script&setup=true&lang=js"
/* custom blocks */
import block0 from "./FormComponent.vue?vue&type=custom&index=0&blockType=stlye&lang=scss"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__